import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class Formatter extends Vue {
  /**
   * Function which determines the value's color representation based on its value
   */
  public getColorBasedOnValue(val: number) {
    if (val > 0) return "green--text";
    if (val < 0) return "red--text";
    return "grey--text";
  }

  /**
   * Returns the display value for a certain currency
   */
  public getCurrencyDisplayValue(
    val: number,
    currency: string = "$",
    showSign: boolean = true
  ): string {
    if (val > 0)
      return (showSign ? "+" : "") + currency + this.formatDisplayNumber(val);
    if (val < 0)
      return (
        (showSign ? "-" : "") +
        currency +
        this.formatDisplayNumber(val * -1)
      );
    if (val === 0) return currency + this.formatDisplayNumber(val);
    return "";
  }

  /**
   * 👁‍🗨 Formats the display value for a number in the following format:
   * XXX,XXX.XX
   * X,XXX.XX
   * 0.XXXX
   * 0.00XXXX
   */
  public formatDisplayNumber(val: number): string {
    if (val > 0 && val <= 1) {
      return val < 0.01
        ? val.toLocaleString("en-US", { maximumFractionDigits: 6, minimumFractionDigits: 6 })
        : val.toLocaleString("en-US", { maximumFractionDigits: 4, minimumFractionDigits: 4 });
    }
    return val.toLocaleString("en-US", { maximumFractionDigits: 2 });
  }
}
